"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var typedi_1 = require("typedi");
var hasOwnProperty_1 = require("./hasOwnProperty");
function getService(type) {
    try {
        if (typeof type !== 'string' && (0, hasOwnProperty_1.hasOwnProperty)(type, '__alias')) {
            type = type.__alias;
        }
        if (typeof type === 'string') {
            if (CommonService_decorator_1.commonServiceMap.has(type)) {
                return typedi_1.Container.get(CommonService_decorator_1.commonServiceMap.get(type));
            }
            else if (typedi_1.Container.has(type)) {
                return typedi_1.Container.get(type);
            }
            else {
                throw new Error('No service with name ' +
                    type +
                    ' was found. Please register your custom service or choose one from these: ' +
                    __spreadArray([], __read(CommonService_decorator_1.commonServiceMap.keys()), false).join(',\n'));
            }
        }
        return typedi_1.Container.get(type);
    }
    catch (ex) {
        console.error('failed to retrieve service with type or name: ', type);
        throw ex;
    }
}
exports.getService = getService;
//# sourceMappingURL=getService.js.map